var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"esports-wrapper"},[(_vm.showHeader)?_c('div',{ref:"header",staticClass:"app-header"},[_vm._t("header",function(){return [_vm._v("Esports")]})],2):_vm._e(),_c('div',{ref:"iframeMount",staticClass:"iframe-host",attrs:{"id":"esports-iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }